import React from 'react'
import { createBrowserRouter, Outlet } from 'react-router-dom'
import { render } from 'react-dom'
import { Router } from '@remix-run/router'
import { Main } from './Components/Main'
import { RouterContainer } from './Common/RouterContainer'
import { BaseContexts } from '../React/Common/BaseContexts'
import { routerState$ } from '../NonReact/common/RxJS/RouterState'
import { Route } from '../NonReact/Types/Types'
import './Pages'
import { ErrorView } from './Components/Organisms/Error/ErrorView'

routerState$.subscribe((routes: Route[]): void => {
    const router: Router = createBrowserRouter(
        [
            {
                element: (
                    <RouterContainer>
                        <Outlet />
                    </RouterContainer>
                ),
                children: routes,
                hasErrorBoundary: true,
                errorElement: <ErrorView />
            }
        ],
        {
            basename: '/CCS/App/v2'
        }
    )

    render(
        <BaseContexts isRouterMode={true}>
            <Main router={router} />
        </BaseContexts>,
        document.getElementById('react-root')
    )
})
